module.exports = __webpack_public_path__ + "static/media/logo.c210f77e.png";